import { HttpClient, HttpParams } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../environments/environment';
import { OcuSummary, OcuTelemetry } from './ocu.model';

export class OcuRepositoryHttp {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.apiBaseUrl}/ocus`;

  listAll(): Observable<OcuSummary[]> {
    return this.http.get<OcuSummary[]>(this.baseUrl);
  }

  getLatestTelemetry(ocuSerialNumber: string): Observable<OcuTelemetry> {
    const params = new HttpParams().set('_', Date.now());
    return this.http.get<OcuTelemetry>(
      `${this.baseUrl}/${encodeURIComponent(ocuSerialNumber)}/telemetry/latest`,
      { params },
    );
  }
}
